<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="time" :variableData="variableDataComponent">
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-4 time">
                  <label>Hora mínima:</label>
                  <VueCtkDateTimePicker
                    id="initialTime"
                    ref="initialTime"
                    v-model="variableDataComponent.config.initialTime"
                    only-time
                    format="HH:mm"
                    formatted="HH:mm:00"
                    input-size="sm"
                    color="#48c0f5"
                    label="Seleccione"
                    no-label
                    no-header
                    :error="variableDataComponent.config.errorTime > 0"
                  />
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 time">
                  <label>Hora máxima:</label>
                  <VueCtkDateTimePicker
                    id="finalTime"
                    ref="finalTime"
                    v-model="variableDataComponent.config.finalTime"
                    only-time
                    format="HH:mm"
                    formatted="HH:mm:00"
                    input-size="sm"
                    color="#48c0f5"
                    label="Seleccione"
                    no-label
                    no-header
                    :error="variableDataComponent.config.errorTime > 0"
                  />
                </div>
                <div
                  v-if="variableDataComponent.config.errorTime > 0"
                  class="col-sm-12 col-md-6 col-lg-4 text-danger invalid-feedback d-block px-1"
                >
                  <b>Error:</b><br />Verifique, debe ser un rango válido de
                  horas (hora inicial &lt; hora final)
                  <InputText
                    class="hide-field"
                    id="Errors"
                    name="Errors"
                    validate="noerrors"
                    label="Errores"
                    :value.sync="variableDataComponent.config.errorTime"
                  />
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
        <!-- lastInitialTime: {{ lastInitialTime }}<br>
          lastFinalTime: {{ lastFinalTime }}<br>
          errorTime: {{ errorTime }}<br> -->
      </template>
    </generalForm>
  </div>
</template>

<script>
import generalForm from '@/src/components/variables/general-form'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import InputText from '@components/form/InputText'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'timeComponent',
  components: {
    generalForm,
    VueCtkDateTimePicker,
    InputText,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      defaultConfig: {
        initialTime: null,
        finalTime: null,
        errorTime: 0,
      },
    }
  },
  methods: {
    validateHour(value) {
      if (
        parseInt(value.initialTime.replace(':', '')) >=
          parseInt(value.finalTime.replace(':', '')) ||
        parseInt(value.finalTime.replace(':', '')) <=
          parseInt(value.initialTime.replace(':', ''))
      ) {
        value.errorTime = 1
      } else {
        value.errorTime = 0
      }
    },
  },
  mounted() {
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
    this.lastInitialTime = this.variableDataComponent.config.initialTime
    this.lastFinalTime = this.variableDataComponent.config.finalTime
  },
  watch: {
    variableDataComponent: {
      deep: true,
      handler(newValue) {
        this.validateHour(newValue.config)
      },
    },
  },
}
</script>

<style lang="scss">
.time {
  .datepicker {
    min-width: 160px !important;
    max-width: 160px !important;
  }
  .field.sm .field-input {
    font-size: 0.85rem !important;
  }
  .field.has-error .field-input {
    padding-top: 0px !important;
  }
}
.hide-field {
  display: none;
}
.radio-group label {
  font-weight: normal !important;
}
</style>
